(function () {
  let swiperTechnology;
  const sectionScrollHandlers = new WeakMap();

  const initTechnology = (section) => {
    if (!section || !section.classList.contains('technology-section')) return;

    const swiperEl = section.querySelector('.technology__swiper');
    if (!swiperEl) return;

    const slides = section.querySelectorAll('.technology__slide');
    if (!slides || slides.length <= 1) return;

    const prevButton = section.querySelector('.technology__nav-button--prev');
    const nextButton = section.querySelector('.technology__nav-button--next');

    if (swiperTechnology) {
      swiperTechnology.destroy(true, true);
    }

    // Preload all videos immediately when section initializes
    const allVideos = section.querySelectorAll('.technology__video');
    let firstVideoAutoPlayed = false; // Track if first video has been auto-played

    const preloadVideos = () => {
      allVideos.forEach((video) => {
        // Ensure video is muted
        video.muted = true;
        
        // Force video to load
        video.load();
        
        // Set preload attribute to ensure full loading
        video.setAttribute('preload', 'auto');
        
        // Wait for video to have enough data to play
        const ensureVideoReady = () => {
          if (video.readyState >= 3) {
            // Video has enough data (HAVE_FUTURE_DATA or HAVE_ENOUGH_DATA)
            // Seek to start to ensure it's ready
            video.currentTime = 0;
          } else {
            // Wait for more data
            video.addEventListener(
              'canplaythrough',
              () => {
                video.currentTime = 0;
              },
              { once: true }
            );
          }
        };
        
        if (video.readyState >= 2) {
          ensureVideoReady();
        } else {
          video.addEventListener(
            'loadedmetadata',
            ensureVideoReady,
            { once: true }
          );
        }
      });
    };
    
    // Start preloading videos immediately
    preloadVideos();

    swiperTechnology = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 40,
      speed: 800,
      allowTouchMove: true,
      loop: false,
      effect: 'fade',
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
        disabledClass: 'swiper-button-disabled',
      },
      on: {
        init: function () {
          handleVideoPlayback(this);
        },
        slideChange: function () {
          handleVideoPlayback(this);
        },
      },
    });

    // Check if technology section's bottom is visible in viewport on scroll
    const checkSectionVisibility = () => {
      const sectionRect = section.getBoundingClientRect();
      const sectionBottom = sectionRect.bottom;
      const viewportBottom = window.innerHeight || document.documentElement.clientHeight;

      // Check if section's bottom line is above the bottom of viewport
      if (sectionBottom < viewportBottom && sectionBottom > 0 && !firstVideoAutoPlayed) {
        console.log('Technology section bottom is visible in viewport');

        // Get first slide and its video
        const firstSlide = slides[0];
        if (!firstSlide) return;

        const firstVideo = firstSlide.querySelector('.technology__video');
        if (!firstVideo) return;

        // Ensure video is muted for autoplay
        firstVideo.muted = true;

        // Reset to start
        firstVideo.currentTime = 0;

        // Function to play the video
        const playVideo = () => {
          firstVideo
            .play()
            .then(() => {
              firstVideoAutoPlayed = true;
              console.log('First video started playing');
            })
            .catch((error) => {
              console.warn('First video autoplay failed:', error);
            });
        };

        // Wait for video to be ready to play
        const attemptPlay = () => {
          if (firstVideo.readyState >= 2) {
            // Video has enough data, try to play
            requestAnimationFrame(playVideo);
          } else {
            // Wait for video to load
            const onReady = () => {
              requestAnimationFrame(playVideo);
            };

            // Listen for when video can play
            firstVideo.addEventListener('canplay', onReady, { once: true });
            firstVideo.addEventListener('loadeddata', onReady, { once: true });

            // Fallback: try after a delay
            setTimeout(() => {
              if (firstVideo.paused && firstVideo.readyState >= 1 && !firstVideoAutoPlayed) {
                playVideo();
              }
            }, 300);
          }
        };

        attemptPlay();
      }
    };

    // Throttle scroll events for better performance
    let scrollTimeout;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        checkSectionVisibility();
      }, 100);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    sectionScrollHandlers.set(section, handleScroll);

    // Initial check in case section is already visible
    checkSectionVisibility();

    // Handle video playback when slide becomes visible
    function handleVideoPlayback(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      // Pause all videos in the section
      allVideos.forEach((video) => {
        if (video.pause) {
          video.pause();
        }
      });

      // Play video in active slide
      const activeVideo = activeSlide.querySelector('.technology__video');
      if (activeVideo) {
        // Ensure video is muted for autoplay
        activeVideo.muted = true;
        
        // Check if we need to seek (before resetting)
        const needsSeek = Math.abs(activeVideo.currentTime) > 0.1;
        
        // Always reset to start
        activeVideo.currentTime = 0;
        
        // Function to play the video
        const playVideo = () => {
          activeVideo
            .play()
            .catch((error) => {
              console.warn('Video autoplay failed:', error);
            });
        };

        // Wait for video to be ready to play
        const attemptPlay = () => {
          // Check if video has enough data
          if (activeVideo.readyState >= 2) {
            // Video has metadata, try to play
            requestAnimationFrame(playVideo);
          } else {
            // Wait for video to load
            const onReady = () => {
              requestAnimationFrame(playVideo);
            };
            
            // Listen for when video can play
            activeVideo.addEventListener('canplay', onReady, { once: true });
            activeVideo.addEventListener('loadeddata', onReady, { once: true });
            
            // Fallback: try after a delay
            setTimeout(() => {
              if (activeVideo.paused && activeVideo.readyState >= 1) {
                playVideo();
              }
            }, 300);
          }
        };

        // If we needed to seek, wait for seek to complete
        if (needsSeek) {
          const onSeeked = () => {
            activeVideo.removeEventListener('seeked', onSeeked);
            attemptPlay();
          };
          activeVideo.addEventListener('seeked', onSeeked, { once: true });
          
          // Fallback if seeked doesn't fire
          setTimeout(attemptPlay, 150);
        } else {
          // No seek needed, try to play immediately
          attemptPlay();
        }
      }
    }

    // Initialize video end handlers for all videos on page load
    // This ensures videos pause on the last frame when they end
    allVideos.forEach((video) => {
      // Ensure video is muted
      video.muted = true;
      
      // Only add listener if not already added (check with data attribute)
      if (!video.dataset.endedHandlerAdded) {
        video.dataset.endedHandlerAdded = 'true';
        video.addEventListener('ended', function () {
          this.pause();
          // Seek to end to show last frame (if duration is available)
          if (this.duration && isFinite(this.duration)) {
            this.currentTime = this.duration;
          }
        });
      }
    });
  };

  const destroyTechnology = (section) => {
    if (swiperTechnology) {
      swiperTechnology.destroy(true, true);
      swiperTechnology = null;
    }

    // Clean up scroll event listener
    const scrollHandler = sectionScrollHandlers.get(section);
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      sectionScrollHandlers.delete(section);
    }
  };

  // Initial run
  initTechnology(document.currentScript.parentElement);

  // Section load events
  document.addEventListener('shopify:section:load', function (event) {
    initTechnology(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyTechnology(event.target);
  });
})();

